export default __webpack_public_path__ + "static/hero_business_back_img_2-a28c0fab816d603ca49b9fb8d1030204.png";